import { render, staticRenderFns } from "./JSelectDepartModal.vue?vue&type=template&id=22d28285&scoped=true&"
import script from "./JSelectDepartModal.vue?vue&type=script&lang=js&"
export * from "./JSelectDepartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d28285",
  null
  
)

export default component.exports